// Relacionamento Familiar
export const textoEspec1 = (
  <span>
    Conflitos familiares podem envolver <strong>culpa, insegurança, excesso de cobrança, dificuldade em se posicionar e construir limites mais saudáveis</strong>.
  </span>
);

// Relacionamento Amoroso
export const textoEspec2 = (
  <span>
    <strong>Ciúmes, segurança, dependência emocional, relacionamentos tóxicos e padrões repetitivos</strong> de comportamento impactam diretamente a forma de amar e se respeitar.
  </span>
)

// Autoestima e autoconfiança
export const textoEspec3 = (
  <span>
    A dificuldade em <strong>considerar o próprio valor, a comparação constante</strong>, a vergonha e a autossabotagem relacionadas à forma como você se vê.
  </span>
)

// Transtornos e Gerenciamento de Emoções
export const textoEspec4 = (
  <span>
    Culpa, preocupação excessiva, medo de julgamento e dificuldades na regulação emocional podem gerar sofrimento constante.
  </span>
)

// Ansiedade (Pânico, Fobias e TOC)
export const textoEspec5 = (
  <span>
    A ansiedade pode se manifestar por insegurança, dificuldade em tomar decisões, <strong>medo de errar e excesso de cobrança interna</strong>.
  </span>
)

// Estresse, Depressão e Humor
export const textoEspec6 = (
  <span>
    Estados persistentes de cansaço emocional, desânimo, autocrítica intensa e sensação de sobrecarga podem sinalizar sofrimento psíquico.
  </span>
)

// Tratamento Comprovado
export const textoEspec7 = (
  <span>
    Um processo terapêutico baseado em ciência e os melhores estudos, vasta experiência clínica e direcionamento claro para mudanças consistentes.
  </span>
)

// Bem estar integral
export const textoEspec8 = (
  <span>
    O acompanhamento psicológico promove maior clareza, estabilidade emocional e recursos para lidar com as exigências do cotidiano.
  </span>
)

// Facilidade e Flexibilidade
export const textoEspec9 = (
  <span>
    Atendimento on-line, com horários flexíveis e organização que se adaptam à sua rotina e necessidades, mesmo em horários não convencionais.
  </span>
)

// Apoio Contínuo
export const textoEspec10 = (
  <span>
    Você não percorre esse caminho sozinho: acompanhamento próximo, consistente e respeitoso em cada etapa.
  </span>
)

// Acolhimento Profissional
export const textoEspec11 = (
  <span>
    Um espaço seguro, sem julgamentos, onde você pode falar livremente e ser realmente escutado(a).
  </span>
)

// Terapia Personalizada
export const textoEspec12 = (
  <span>
    Nada de fórmulas prontas. O processo é construído a partir de sua história, necessidades e objetivos.
  </span>
)